import {useTranslation} from 'react-i18next';
import React from 'react';
import {Grid} from '@mui/material';
import FormikNumberField from 'components/inputs/FormikNumberField';
import {SubkeysExpirationNames} from 'types/diplomat/keys/AddOpenPGPSubKey';

const SubkeysExpirationField = () => {
   const {t} = useTranslation();

   const [helperText, setHelperText] = React.useState('');

   const handleDurationChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
      const duration = Number(ev.target.value);
      const isYear = duration % 365 === 0;
      if (isYear) {
         const yearsCount = duration / 365;
         setHelperText(`${yearsCount} year${yearsCount > 1 ? 's' : ''}`);
      } else {
         setHelperText('');
      }
   };
   return (
      <>
         <Grid item xs={6}>
            <FormikNumberField
               name={SubkeysExpirationNames.keysCount}
               label={t('Keys count')}
               // onChange={handleCountChange}
               min={1}
            />
         </Grid>
         <Grid item xs={6}>
            <FormikNumberField
               name={SubkeysExpirationNames.keysDuration}
               label={t('Keys duration (days)')}
               min={1}
               onChange={handleDurationChange}
               helperText={helperText}
            />
         </Grid>
      </>
   );
};

export default SubkeysExpirationField;
